import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import Text from '../../components/simple/text/Text'
import Select from '../../components/simple/input/Select.js'

import ReactToPrint from "react-to-print";

// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import RelatedIncidents from './common/RelatedIncidents.js';
import RelatedConcerns from './common/RelatedConcerns.js';
import RelatedClickers from './common/RelatedClickers.js';


import LocalStorageService from '../../services/LocalStorageService'

import { reportsByType } from '../../utils/reportMapping.js'

import ReportService from '../../services/ReportService.js'

import ClickerReport from './panels/ClickerReport.js'
import IncidentReport from './panels/IncidentReport.js'
import ConcernReport from './panels/ConcernReport.js'
import InvolvementReport from './panels/InvolvementReport.js'
import InterventionReport from './panels/InterventionReport.js'
import MedicalInterventionReport from './panels/MedicalInterventionReport.js'
import PILExtrasReport from './panels/PILExtrasReport.js'

import AnalyticsFilters from './common/AnalyticsFilters.js'
import queryString from 'query-string'

import { decodeFiltersFromQueryString } from '../../utils/analytics.js'

import PulseLoader from 'react-spinners/PulseLoader'
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import { isServiceAdmin } from '../../utils/permissions.js'


const Analytics = (props) => {
  const navigate = useNavigate()
  const activeOrg = LocalStorageService.get('activeOrg');
  const apiToken = LocalStorageService.get('apiToken')

  const location = useLocation()

  const params = queryString.parse(location.search)


  const [relatedIncidents, setRelatedIncidents] = useState([]);
  const [relatedClickers, setRelatedClickers] = useState([]);
  const [relatedConcerns, setRelatedConcerns] = useState([]);
  const [significantIncidents, setSignificantIncidents] = useState([]);

  const [filters, setFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [filtersVisible, setFiltersVisible] = useState(false);

  const [reportData, setReportData] = useState({});


    let reports = [

        {
            id: 'IncidentReport',
            name: 'Global Incident Report',
            description: 'Top individuals, groups, times and locations.',
            url: '/incident/report/search',
            source: 'incidents',
        },
        {
            id: 'InterventionReport',
            name: 'Intervention Report',
            description: 'Overview of interventions.',
            url: '/intervention/report/search',
            source: 'incidents',
        },
        {
            id: 'InvolvementReport',
            name: 'Involvement Report',
            description: 'Key involvement in incidents.',
            url: '/involvement/report/search',
            source: 'incidents',
        },
        {
            id: 'MedicalInterventionReport',
            name: 'Injuries Report',
            description: 'Overview of injuries.',
            url: '/medicalIntervention/report/search',
            source: 'incidents',
        },
        {
            id: 'ConcernReport',
            name: 'Communication Report',
            description: 'Overview of communications.',
            url: '/log/report/search',
            source: 'concerns',
        },
        {
            id: 'ClickerReport',
            name: 'Clicker Report',
            description: 'Overview of clicker.',
            url: '/clicker/report/search',
            source: 'clickers',
        }

    ];

    if (activeOrg.enablePILExtras) {
        reports.push({
            id: 'PILExtrasReport',
            name: 'Discriminatory, Prejudiced and other Behaviour',
            description: 'Suspensions & Permanent Exclusions',
            url: '/incidentreportExtras/report/search',
            source: 'incidents',
        })
    }
  const [selectedReport, setSelectedReport] = useState(reports[0])

  useEffect(() => {

    let filtersToUse = [...filters]

    if (filtersToUse.length === 0) {
      if (params.query) {
        try {
          let decoded = decodeFiltersFromQueryString(params.query)
          filtersToUse = decoded
          setFilters(decoded)
        } catch (e) {
          console.error('Error parsing filters from URL:', e)
        }
      }
    }

    if (filtersToUse.length > 0) {
      setFiltersVisible(true)
    }

    getReport(filtersToUse)
  }, [selectedReport, filters])



    const getReport = async (newFilters) => {
        // if (queryArray) {
        let queryArray = [...newFilters]

        let submissionTypeToUse = 'incidentreport'
        if (selectedReport.id === 'MedicalInterventionReport') {
            submissionTypeToUse = 'medicalinterventionreport'
        }

        if (selectedReport.id === 'ConcernReport') {
            submissionTypeToUse = 'concern'
        }

        if (selectedReport.id === 'ClickerReport') {
            submissionTypeToUse = 'clicker'
        }


        const body = {
            submissionType: submissionTypeToUse,
            query: queryArray,
            reports: reportsByType[selectedReport.id],
        };

        const params = {
            orgId: activeOrg.id
        }

        setIsLoading(true);
        try {
          var results = await ReportService.getReport(apiToken, params, body)
        } catch (e) {
          console.error('Error getting report data:', e);
        }
        setIsLoading(false);

        setReportData(results)

        if (results?.incidentSearch) {
          setRelatedIncidents(results.relatedIncidents);
        }

        if (results?.significantIncidents) {
          setSignificantIncidents(results.significantIncidents);
        }

        if (results?.concernSearch) {
          setRelatedConcerns(results.concernSearch);
        }

        if (results?.clickerSearch) {
          setRelatedClickers(results.clickerSearch);
        }

        return results

    }



  let componentRef = null
  let setComponentRef = (ref) => {
    componentRef = ref;
  };

  let reactToPrintContent = () => {
    return componentRef;
  };


  const addFilter = (key, response, operator = 'is') => {
    let newFilters = [...filters];
    newFilters.push({ key: key, operator: operator, response: String(response), "relation": null });
    setFilters(newFilters);
  }

  const addFilters = (newFilterArray) => {
    let newFilters = [...filters, ...newFilterArray];
    setFilters(newFilters);
  }

  const handleAnalyticsFilterSubmit = (newFilters) => {
    setFilters(newFilters);
    getReport(newFilters);
  }

  useEffect(() => {
    if (!isServiceAdmin()) {
      navigate(-1);
    }
  }, [])

  const renderActionButtons = () => {
    return (
      <>
       <ReactToPrint
            content={reactToPrintContent}
            documentTitle="AwesomeFileName"
            removeAfterPrint
            trigger={() => {
              return <ActionButton size='small' label='Print' primary />
            }}
        />
        <ActionButton
          size='small'
          onClick={() => {
            setFiltersVisible(!filtersVisible);
          }}
          label={filtersVisible ? 'Hide Filters' : 'Show Filters'}
          primary
        />
      </>
    )
  }

  return (
    <>
      <BreadcrumbBar
        title="Analytics"
        path={<><Anchor href='/'>BehaviourSmart</Anchor><Text color='besmartBlue' size='xsmall'>{window.location.pathname}</Text></>}
      />

      <Box background='white' direction='row' gap='small' margin={{ bottom: 'small' }} round='small' flex='grow' justify='between' align='center' wrap={false} fill>
        <Box direction='column' pad={{ horizontal: 'medium' }}>
          {/* <H2 color='besmartBlue' margin={{ top: 'small', bottom: 'small' }}>Report</H2> */}
              <Box direction='column' align='start' justify='center' pad={{ vertical: 'medium' }} gap='none'>
                <Text size='large' color='besmartBlue'>You are viewing the <strong>{selectedReport?.name}</strong></Text>
                <Text size='medium' color='besmartBlue'>
                {selectedReport?.description}
                </Text>
                {/* <Text>Filters: {JSON.stringify(filters)}</Text> */}
            </Box>
        </Box>
        <Box direction='row' pad={{ horizontal: 'medium' }}>
            <Box direction='column' align='end' justify='center'>
            <Text size='small' color='dark-3'>Select a report:</Text>
                </Box>
            <Box
              justify="between"
              margin={{ horizontal: 'medium', vertical: 'small' }}
              border={{ side: 'all', color: 'brand', size: 'medium' }}
              round="small"

            >
                <Select
                    onChange={({ option }) => setSelectedReport(option)}
                    labelKey="name"
                    value={selectedReport}
                    options={reports}
                    valueKey={{ key: 'id', reduce: false }}
                    border={false}
                    round="small"
                    focusIndicator={false}
                    plain
                    margin={{ left: 'small', right: 'small' }}
                />
            </Box>



        </Box>


      </Box>


      {selectedReport.source === 'incidents' && <RelatedIncidents additionalButtons={renderActionButtons()} results={relatedIncidents} significantIncidents={significantIncidents} submissions={props?.location?.state?.incidentSearch} />}
      {selectedReport.source === 'concerns' && <RelatedConcerns additionalButtons={renderActionButtons()} results={relatedConcerns} submissions={props?.location?.state?.concernSearch} />}
      {selectedReport.source === 'clickers' && <RelatedClickers additionalButtons={renderActionButtons()} results={relatedClickers} submissions={props?.location?.state?.clickerSearch} />}



      {filtersVisible && <AnalyticsFilters onSubmit={handleAnalyticsFilterSubmit} filters={filters} reportSource={selectedReport.source} />}



      {isLoading && <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }} pad={{ vertical: 'medium' }} align='center' justify='center' background='white' round='small'>
        <Text size='large' weight='bold' color='dark-3'>Loading report data...</Text>
        <PulseLoader
          size={15}
          color='#ff8300'
        />
      </Box>}

      <Box ref={setComponentRef} direction='column' gap='small' round='small'>
            {!isLoading && selectedReport.id === 'IncidentReport' && <IncidentReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
            {!isLoading && selectedReport.id === 'ConcernReport' && <ConcernReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
            {!isLoading && selectedReport.id === 'InvolvementReport' && <InvolvementReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
            {!isLoading && selectedReport.id === 'InterventionReport' && <InterventionReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
            {!isLoading && selectedReport.id === 'MedicalInterventionReport' && <MedicalInterventionReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
            {!isLoading && selectedReport.id === 'ClickerReport' && <ClickerReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
            {!isLoading && selectedReport.id === 'PILExtrasReport' && <PILExtrasReport reportData={reportData} addFilter={addFilter} addFilters={addFilters} filters={filters} />}
      </Box>
    </>
  )
}

export default Analytics
